export default __webpack_public_path__ + "static/media/09-nfz.4d0da04b.jpg";